import { useContext } from 'react'
import AccessContext from './AccessContext'

const useIsAdmin = () => {
    return useContext(AccessContext)
}

export default useIsAdmin
